import React, { Component } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import DevicesListObjectModel from 'src/Models/Device/ListObjectModel'
import { observer } from 'mobx-react'
import { Button, Table } from 'semantic-ui-react'
import dateFormat from 'dateformat'
import CustomerModel from 'src/Models/Payment/Stripe/CustomerModel'
import { firebaseApp } from 'src/config/firebase'
import DeviceInfo from '../Admin/User/Edit/Device/DeviceInfo'
import { activateDevice } from 'src/services/stripe'
import InfoComponent from '../Payment/InfoComponent'
import LicensePurchaseComponent from './LicensePurchaseComponent'
import { Grid, Header } from 'semantic-ui-react'

export default
@observer
class UserComponent extends Component {
  customerModel = null
  deviceModel = null
  hasCustomerId = true

  constructor(props) {
    super(props)

    this.customerModel = new CustomerModel()
    this.deviceModel = new DevicesListObjectModel()
  }

  componentDidMount() {
    const { userID } = this.props

    this.deviceModel.update(userID)

    firebaseApp
      .database()
      .ref('/users/' + userID + '/stripeCustomerId/')
      .once('value')
      .then((snapshot) => {
        const val = snapshot.val()

        if (val) {
          this.customerModel.loadData(val)
        } else {
          this.hasCustomerId = false
          this.forceUpdate()
        }
      })
  }

  activateDevice = async (deviceId) => {
    const { userID } = this.props
    await activateDevice(userID, deviceId)
    this.deviceModel.update(userID)
  }

  deleteDevice = async (deviceKey) => {
    const { userID } = this.props
    if (window.confirm('Are you sure you want to delete this tablet?')) {
      await this.deviceModel.deleteDevice(deviceKey, userID)
    }
  }

  render() {
    if (
      !this.deviceModel.isLoaded ||
      (!this.customerModel.isLoaded && this.hasCustomerId)
    ) {
      return <CircularProgress />
    }

    const { isOwn } = this.props
    const devices = this.deviceModel.devices

    // Check if at least one device has activation code
    const hasAnyActivatedDevice = devices.some((d) => d.activationCode)

    const rows = devices.map((device) => {
      const deviceInfo = new DeviceInfo(device.activationCode, device.id)
      const trialDate = deviceInfo.trial_date
      const untilActivatedDate = deviceInfo.until_activated

      let isTrial = false
      let isManual = false

      if (trialDate) {
        isTrial = trialDate > new Date().getTime()
      }

      if (untilActivatedDate) {
        isManual = untilActivatedDate > new Date().getTime()
      }

      let periodText = ''

      if (isTrial) {
        periodText = dateFormat(new Date(trialDate), 'dd mmmm yyyy')
      } else if (isManual) {
        periodText = dateFormat(new Date(untilActivatedDate), 'dd mmmm yyyy')
      }

      return (
        <Table.Row key={device.key} positive={device.activationCode}>
          <Table.Cell width={2}>{device.id}</Table.Cell>
          <Table.Cell width={2}>{periodText}</Table.Cell>
          <Table.Cell width={3}>
            {!device.activationCode ? (
              <div>
                {hasAnyActivatedDevice && (
                  <Button
                    primary
                    onClick={this.activateDevice.bind(this, device.id)}
                    style={{ marginRight: '8px' }}
                  >
                    Apply License to this Device
                  </Button>
                )}
                <Button
                  color="red"
                  onClick={this.deleteDevice.bind(this, device.key)}
                >
                  Delete
                </Button>
              </div>
            ) : (
              'Applied'
            )}
          </Table.Cell>
        </Table.Row>
      )
    })

    const device =
      devices && devices.length > 0
        ? devices.find((d) => d.activationCode)
        : null

    return (
      <div>
        <InfoComponent device={device} />
        <div style={{ marginTop: '20px' }} />
        <Grid columns={2}>
          <Grid.Column>
            {devices.length === 0 ? (
              <LicensePurchaseComponent
                devices={devices}
                customerId={
                  this.hasCustomerId && this.customerModel.info
                    ? this.customerModel.info.id
                    : null
                }
                paymentMethodId={
                  this.customerModel.info?.defaultPaymentMethod || null
                }
                forcePaymentMethod={true}
                onDeviceAdded={(deviceData) => {
                  // Refresh device list when a device is added
                  console.log('Device added:', deviceData)
                  this.deviceModel.update(this.props.userID)
                }}
                onCustomerCreated={(customerId, paymentMethodId) => {
                  // Refresh customer model when new customer is created
                  this.hasCustomerId = true
                  this.customerModel.loadData(customerId)
                  console.log(
                    'Customer created with paymentMethodId:',
                    paymentMethodId
                  )
                }}
                onPurchaseSuccess={(paymentData, type) => {
                  console.log('Purchase successful:', type, paymentData)
                  // You can add additional success handling here
                  // For example, refresh device data or show confirmation
                  this.deviceModel.update(this.props.userID)
                }}
              />
            ) : (
              devices.length > 0 && (
                <>
                  <Header as="h3">Tablets</Header>
                  <Table celled>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Tablet ID</Table.HeaderCell>
                        <Table.HeaderCell>Expiration date</Table.HeaderCell>
                        {isOwn && (
                          <Table.HeaderCell>
                            <div />
                          </Table.HeaderCell>
                        )}
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>{rows}</Table.Body>
                  </Table>
                </>
              )
            )}
          </Grid.Column>
          <Grid.Column>
            {devices.length > 0 && (
              <LicensePurchaseComponent
                devices={devices}
                customerId={
                  this.hasCustomerId && this.customerModel.info
                    ? this.customerModel.info.id
                    : null
                }
                paymentMethodId={
                  this.customerModel.info?.defaultPaymentMethod || null
                }
                forcePaymentMethod={true}
                onDeviceAdded={(deviceData) => {
                  // Refresh device list when a device is added
                  console.log('Device added:', deviceData)
                  this.deviceModel.update(this.props.userID)
                }}
                onCustomerCreated={(customerId, paymentMethodId) => {
                  // Refresh customer model when new customer is created
                  this.hasCustomerId = true
                  this.customerModel.loadData(customerId)
                  console.log(
                    'Customer created with paymentMethodId:',
                    paymentMethodId
                  )
                }}
                onPurchaseSuccess={(paymentData, type) => {
                  console.log('Purchase successful:', type, paymentData)
                  // You can add additional success handling here
                  // For example, refresh device data or show confirmation
                  this.deviceModel.update(this.props.userID)
                }}
              />
            )}
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}
